import React from 'react';
import './MerchantHistory.scss';
import { getFullDate } from '../../commons/CommonMethods';
import Shimmer from 'sushiweb/Shimmer';

export const MerchantHistory = ({ merchantHistory }) => {
  return (
    <div className='popContent modalContent'>
      {!merchantHistory ? (
        <Shimmer height='100%' width='100%' />
      ) : (
        <MerchantHistoryComp merchantHistory={merchantHistory} />
      )}
    </div>
  );
};

const MerchantHistoryComp = ({ merchantHistory }) => {
  const sections = merchantHistory.sections;
  const rejections = merchantHistory.rejections;
  const issueBreakdown = merchantHistory.issue_breakdown;
  return (
    <div className='row'>
      <div className='col'>
        {sections && (
          <div className='sectionsWrapper'>
            {sections.map((item, index) => {
              return (
                <div key={index} className='sectionsDetails'>
                  <p className='heading dark'>{item.title}</p>
                  {item.text && (
                    <div className='sections'>
                      {item.text.map((title, key) => {
                        let textColor = item.color || 'light';
                        return (
                          <p key={key} className={`subHeading ${textColor} `}>
                            {title}
                          </p>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className='col'>
        {issueBreakdown && (
          <div className='sectionsWrapper'>
            <div className='sectionsDetails'>
              <p className='heading dark'>{issueBreakdown.title}</p>
              {issueBreakdown.text && (
                <div className='sections'>
                  {issueBreakdown.text.map((title, key) => (
                    <p key={key} className='subHeading light'>
                      {title}
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {rejections ? (
          <div className='rejectionsWrapper'>
            <p className='heading dark'>{rejections.title}</p>
            <div className='sections'>
              {rejections.data &&
                rejections.data.map((item, index) => (
                  <p key={index} className='subHeading light'>
                    <span>{getFullDate(item.time)}</span>
                    {item.text && (
                      <span className='rejectionReason'>({item.text})</span>
                    )}
                  </p>
                ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
